import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
    {
        path: '/searchPage',
        component: LAYOUT,
        redirect: '/searchPage/index',
        meta: { title: '站内搜索', showNavPanel: true, hide: true },
        children: [
            {
                path: 'index',
                name: '站内搜索',
                component: () => import('@/views/searchPage/index.vue'),
                meta: { title: '站内搜索' },
            },
        ],
    },
]
